import { Stack } from '@mui/material';

function IconButton({
  children,
  onClick,
  'aria-label': ariaLabel,
  role = 'button',
}) {
  return (
    <Stack
      sx={(theme) => ({
        width: '40px',
        height: '40px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '100%',
        padding: '6px',
        border: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
        cursor: 'pointer',
        overflow: 'hidden',
      })}
      onClick={onClick}
      role={role}
      aria-label={ariaLabel}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      {children}
    </Stack>
  );
}

export default IconButton;
